var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames, formatDateString, truncateMiddle } from '@shapeable/utils';
import { breakpoints, theme } from '@shapeable/theme';
import { useLang } from '../hooks/use-lang';
import { PLATFORM_DATE_FORMAT } from '@shapeable/utils';
import { useMonthNames } from '../hooks/use-month-names';
import { identity, map, pickBy } from 'lodash';
var cls = classNames('citation-cell');
export var CitationCellDefaultProps = {
  isExtended: false,
  showDisplayName: true
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var isExtended = _a.isExtended;
    return isExtended && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      display: flex;\n      flex-direction: row;\n      align-items: flex-start;\n    "], ["\n      display: flex;\n      flex-direction: row;\n      align-items: flex-start;\n    "])));
  })
});
var InfoStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var isExtended = _a.isExtended;
    return isExtended && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      display: block;\n      margin-top: 3px;\n\n      a {\n        word-break: break-all; \n      }\n    "], ["\n      display: block;\n      margin-top: 3px;\n\n      a {\n        word-break: break-all; \n      }\n    "])));
  })
});
var BodyStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var isExtended = _a.isExtended;
    return isExtended && css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      display: flex;\n      flex-direction: column;\n    "], ["\n      display: flex;\n      flex-direction: column;\n    "])));
  })
});
var NumberStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    font-size: ", ";\n    font-weight: 500;\n    text-decoration: none;\n    flex-shrink: 0;\n    border: 1px solid ", ";\n    background: ", ";\n    border-radius: 16px;\n    line-height: 1em;\n    margin-right: ", ";\n    width: ", ";\n    height: ", ";\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n  "], ["\n    font-size: ", ";\n    font-weight: 500;\n    text-decoration: none;\n    flex-shrink: 0;\n    border: 1px solid ", ";\n    background: ", ";\n    border-radius: 16px;\n    line-height: 1em;\n    margin-right: ", ";\n    width: ", ";\n    height: ", ";\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n  "])), theme.FONT_SIZE(10), theme.COLOR('text-mid'), theme.COLOR('light'), theme.UNIT(2), theme.UNIT(5), theme.UNIT(5))
});
var AuthorStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    display: flex;\n  "], ["\n    display: flex;\n  "])))
});
var LinkStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var UrlLinkStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var PublicationStyles = breakpoints({
  base: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var AccessedDateStyles = breakpoints({
  base: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var DateStyles = breakpoints({
  base: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var EditionStyles = breakpoints({
  base: css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var VolumeStyles = breakpoints({
  base: css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ReferencePagesStyles = breakpoints({
  base: css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var YearStyles = breakpoints({
  base: css(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var NameStyles = breakpoints({
  base: css(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n    display: flex;\n  "], ["\n    display: flex;\n  "])))
});
var FieldsStyles = breakpoints({
  base: css(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n    dipslay: block;\n  "], ["\n    dipslay: block;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.span(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Number: styled.span.attrs(cls.attr('number'))(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), NumberStyles),
  Body: styled.span.attrs(cls.attr('body'))(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Fields: styled.div.attrs(cls.attr('fields'))(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), FieldsStyles),
  Info: styled.span.attrs(cls.attr('info'))(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), InfoStyles),
  Name: styled.span.attrs(cls.attr('name'))(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), NameStyles),
  Date: styled.span.attrs(cls.attr('date'))(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), DateStyles),
  Author: styled.span.attrs(cls.attr('author'))(templateObject_27 || (templateObject_27 = __makeTemplateObject(["", ""], ["", ""])), AuthorStyles),
  Link: styled.a.attrs(cls.attr('link'))(templateObject_28 || (templateObject_28 = __makeTemplateObject(["", ""], ["", ""])), LinkStyles),
  Publication: styled.em.attrs(cls.attr('publication'))(templateObject_29 || (templateObject_29 = __makeTemplateObject(["", ""], ["", ""])), PublicationStyles),
  AccessedDate: styled.span.attrs(cls.attr('accessed-date'))(templateObject_30 || (templateObject_30 = __makeTemplateObject(["", ""], ["", ""])), AccessedDateStyles),
  Edition: styled.span.attrs(cls.attr('edition'))(templateObject_31 || (templateObject_31 = __makeTemplateObject(["", ""], ["", ""])), EditionStyles),
  ReferencePages: styled.span.attrs(cls.attr('reference-pages'))(templateObject_32 || (templateObject_32 = __makeTemplateObject(["", ""], ["", ""])), ReferencePagesStyles),
  Volume: styled.span.attrs(cls.attr('volume'))(templateObject_33 || (templateObject_33 = __makeTemplateObject(["", ""], ["", ""])), VolumeStyles),
  Year: styled.span.attrs(cls.attr('year'))(templateObject_34 || (templateObject_34 = __makeTemplateObject(["", ""], ["", ""])), YearStyles),
  UrlLink: styled.a.attrs(cls.attr('url-link'))(templateObject_35 || (templateObject_35 = __makeTemplateObject(["", ""], ["", ""])), UrlLinkStyles)
};
export var CitationCell = function (props) {
  var className = props.className,
    entity = props.entity,
    isExtended = props.isExtended,
    number = props.number,
    urlMaxLength = props.urlMaxLength,
    showName = props.showName,
    showDisplayName = props.showDisplayName;
  var _a = entity.authors,
    authors = _a === void 0 ? [] : _a,
    url = entity.url,
    authorShowsEtAl = entity.authorShowsEtAl,
    footnoteNumber = entity.footnoteNumber,
    publication = entity.publication,
    name = entity.name,
    date = entity.date,
    accessDate = entity.accessDate,
    edition = entity.edition,
    volume = entity.volume,
    year = entity.year,
    startPage = entity.startPage,
    endPage = entity.endPage;
  var hasAuthor = !!authors.length;
  var numberToUse = number || footnoteNumber;
  var hasNumber = numberToUse !== undefined && !!numberToUse && isExtended;
  var author = "".concat(authors.map(function (author) {
    return author.name;
  }).join(', ')).concat(authorShowsEtAl ? ' et al.' : '');
  var t = useLang();
  var monthNames = useMonthNames();
  var formattedAccessDate = accessDate && formatDateString(accessDate, t('Do MMM YYYY'), PLATFORM_DATE_FORMAT, {
    monthNames: monthNames
  });
  var transformers = {
    volume: function (value) {
      return "Vol. ".concat(value);
    },
    startPage: function (value) {
      return "p.".concat(value);
    },
    accessDate: function (value) {
      return "accessed ".concat(value);
    }
  };
  var fields = pickBy({
    date: date,
    publication: publication,
    edition: edition,
    volume: volume,
    year: year,
    startPage: startPage,
    accessDate: formattedAccessDate
  });
  var formattedFields = map(fields, function (value, fieldName) {
    return (transformers[fieldName] || identity)(value);
  });
  return React.createElement(My.Container, {
    isExtended: isExtended,
    className: cls.name(className)
  }, hasNumber && React.createElement(My.Number, null, numberToUse), React.createElement(My.Body, {
    isExtended: isExtended
  }, React.createElement(My.Info, {
    isExtended: isExtended
  }, hasAuthor && React.createElement(My.Author, null, author), showDisplayName && React.createElement(React.Fragment, null, isExtended ? showName && React.createElement(My.Name, null, "\u2018", name, "\u2019") : React.createElement(My.Link, {
    target: "_blank",
    href: url
  }, "\u2018", name, "\u2019")), React.createElement(My.Fields, null, formattedFields.join(', '), !!formattedFields.length && '.')), isExtended && React.createElement(My.UrlLink, {
    target: "_blank",
    href: url
  }, urlMaxLength ? truncateMiddle(url, urlMaxLength) : url)));
};
CitationCell.defaultProps = CitationCellDefaultProps;
CitationCell.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35;